import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { FnCallPipe } from '@core/common-legacy';

import type { IconName } from '../common/icon/icons.type';

@Component({
  standalone: true,
  selector: 'rt-icons-container',
  // This template is generated by script in /scripts/generate-icons.js
  templateUrl: './icons-container.component.html',
  styleUrls: ['./icons-container.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FnCallPipe],
})
export class IconsContainerComponent {
  private readonly domSanitizer = inject(DomSanitizer);

  protected icons = computed(() =>
    Object.entries(this.visibleIcons()).map(([name, symbol]) => ({ name, symbol })),
  );

  private visibleIcons = signal<Partial<Record<IconName, string>>>({});

  public hasVisibleIcon(name: IconName) {
    return !!this.visibleIcons()[name];
  }

  public updateVisibleIcons(name: IconName, symbol: string) {
    this.visibleIcons.update(icons => ({ ...icons, [name]: symbol }));
  }

  protected safeHtml = (symbol: string) =>
    // eslint-disable-next-line ban/ban
    this.domSanitizer.bypassSecurityTrustHtml(symbol);
}
